import React from "react";

/** Fluent Tab Desktop — Facility Network (sidebar + page title). */
const TAB_DESKTOP_PATH =
  "M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14ZM13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13ZM15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14ZM5 7.5C5 6.11929 6.11929 5 7.5 5H16.5C17.8807 5 19 6.11929 19 7.5V16.5C19 17.8807 17.8807 19 16.5 19H7.5C6.11929 19 5 17.8807 5 16.5V7.5ZM7.5 6C6.67157 6 6 6.67157 6 7.5V16.5C6 17.3284 6.67157 18 7.5 18H16.5C17.3284 18 18 17.3284 18 16.5V9H11.5C10.6716 9 10 8.32843 10 7.5V6H7.5ZM18 7.5C18 6.67157 17.3284 6 16.5 6H11V7.5C11 7.77614 11.2239 8 11.5 8H18V7.5Z";

type Props = {
  size?: number;
  fill?: string;
};

export default function FacilityNetworkIcon({
  size = 20,
  fill = "#262626",
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path d={TAB_DESKTOP_PATH} fill={fill} />
    </svg>
  );
}
